import { render } from "./CxObject.vue?vue&type=template&id=c6dcf088"
import script from "./CxObject.vue?vue&type=script&lang=js"
export * from "./CxObject.vue?vue&type=script&lang=js"

import "./CxObject.vue?vue&type=style&index=0&id=c6dcf088&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__